import { render, staticRenderFns } from "./Myinfo.vue?vue&type=template&id=148e05e9&scoped=true&"
import script from "./Myinfo.vue?vue&type=script&lang=js&"
export * from "./Myinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e05e9",
  null
  
)

export default component.exports